import React, { useMemo } from 'react'
import { Button, Card, Empty, Flex, Space, Statistic } from 'antd'
import FileCardNewTextContainer from '../../../components/file-card/FileCardNewTextContainer'
import groupSelectors from '../../../../../store/selectors/group.selectors'
import { useDispatch, useSelector } from 'react-redux'
import { useThemeColors } from '../../../../../hooks/useThemeColors'
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons'
import { groupActions } from '../../../../../store/slices/group.slice'
import Title from 'antd/es/typography/Title'
import './submissions-groups-card.scss'
import PatternIcon from '../../../../../components/common/PatternIcon'
import { isNumber } from 'lodash'

const SubmissionsGroupCard = ({ id, submissions, title, colorId, totalSubmissions, groups }) => {
    const colors = useThemeColors()
    const isGroupCollapsed = useSelector(groupSelectors.isGroupCollapsed(id))
    const dispatch = useDispatch()

    const submissionCards = useMemo(() => {
        return isGroupCollapsed && submissions?.length > 1
            ? [
                  <FileCardNewTextContainer
                      key={submissions[0].id}
                      id={submissions[0].id}
                      name={submissions[0].studentId}
                      groups={groups}
                      badgeProps={{
                          count: submissions.length,
                          title: `${submissions.length} submissions in this group`,
                          overflowCount: 9999,
                          color: colors.primary,
                      }}
                  />,
              ]
            : submissions?.map(submission => (
                  <FileCardNewTextContainer
                      key={submission.id}
                      id={submission.id}
                      name={submission.studentId}
                      groups={groups}
                      approveStatus={submission.approveStatus}
                      mismatchPredicted={submission.mismatchPredicted}
                  />
              ))
    }, [submissions, isGroupCollapsed, groups])

    const cardExtra = useMemo(() => {
        const percentFromTotal = Math.round((submissions?.length / totalSubmissions) * 100)
        return (
            <Flex gap={32} wrap='wrap'>
                {submissions?.length ? (
                    <Statistic title='Submissions' value={`${submissions?.length} (${percentFromTotal}%)`} />
                ) : null}
            </Flex>
        )
    }, [submissions?.length, totalSubmissions])

    const titleElement = (
        <Space>
            <Title level={3} className='submissions-group-card-title' style={{ color: colors.text }}>
                <Space size={8}>
                    {isNumber(colorId) ? <PatternIcon id={id} colorId={colorId} showId={false} /> : null}
                    {title}
                </Space>
            </Title>
            {Boolean(submissions?.length) && (
                <Button
                    type='text'
                    shape='circle'
                    icon={isGroupCollapsed ? <ArrowsAltOutlined /> : <ShrinkOutlined />}
                    onClick={() => dispatch(groupActions.toggleGroupCollapse(id))}
                    title={isGroupCollapsed ? `Expand group` : `Collapse group`}
                    style={{ color: colors.text }}
                />
            )}
        </Space>
    )

    return (
        <Card 
            bordered={true} 
            title={titleElement} 
            extra={cardExtra} 
        >
            {submissionCards?.length ? (
                <Space size={8} wrap>
                    {submissionCards}
                </Space>
            ) : (
                <Empty description='There are no submissions' image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
        </Card>
    )
}

export default SubmissionsGroupCard
